export default "__VITE_ASSET__Dh8xXAEk__"